import { ConnectedPosition } from '@angular/cdk/overlay'
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { VuosiKk } from '../../../_angular/service/tosite/tosite-datasource-uusi.service'

@Component({
  selector: 'app-kuukausi-valinta',
  templateUrl: './kuukausi-valinta.component.html',
  styleUrls: ['./kuukausi-valinta.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KuukausiValintaComponent {
  @Input() otsikko = ''
  @Input() set valittuKuukausi(vuosiKk: VuosiKk | null) {
    this.valittuPvm = vuosiKk ? new Date(vuosiKk.vuosi, vuosiKk.kk, 1) : null
  }
  @Input() edellisenKkSelvitettavat = 0
  @Input() seuraavanKkSelvitettavat = 0
  @Output() edellinenKk = new EventEmitter<void>()
  @Output() seuraavaKk = new EventEmitter<void>()
  @Output() kuukausiValittu = new EventEmitter<VuosiKk>()

  valittuPvm: Date | null = null
  kalenteriAuki = false

  readonly kalenterinSijainnit: ConnectedPosition[] = [
    { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 8 },
    { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetY: -8 },
  ]

  avaaKalenteri() {
    this.kalenteriAuki = true
  }

  suljeKalenteri() {
    this.kalenteriAuki = false
  }

  kasitteleKalenterinNappain(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.suljeKalenteri()
    }
  }

  valitseKuukausi(pvm: Date) {
    this.kalenteriAuki = false
    this.kuukausiValittu.emit({ vuosi: pvm.getFullYear(), kk: pvm.getMonth() })
  }
}
